import axios, { AxiosError, AxiosResponse } from 'axios'
import { handleError } from './ErrorHandlers'

export const get = async (url: string) => {
   try {
      const response: AxiosResponse = await axios.get(url)
      if (response.status === 200 || response.status === 201 || response.status === 204) {
         return response.data
      } else {
         throw new Error(response.statusText)
      }
   } catch (err) {
      handleError(err)
      throw err
   }
}

export const post = async (
   url: string,
   data: any,
   handleErrors: boolean = true
): Promise<object> => {
   try {
      const response: AxiosResponse = await axios.post(url, data)
      if (!handleErrors) {
         return response.data
      }
      if (response.status === 200 || response.status === 201) {
         return response.data
      } else {
         throw new Error(response.statusText)
      }
   } catch (err) {
      if (!handleErrors) {
         const response = (err as AxiosError).response
         return response ? response.data : {}
      } else {
         handleError(err)
      }
      throw err
   }
}

export const del = async (url: string): Promise<object> => {
   try {
      const response: AxiosResponse = await axios.delete(url)
      if (response.status === 200) {
         return response.data
      } else {
         throw new Error(response.statusText)
      }
   } catch (err) {
      handleError(err)
      throw err
   }
}

export const deleteWithData = async (url: string, data: object): Promise<void> => {
   try {
      const response: AxiosResponse = await axios.delete(url, { data })
      if (response.status === 200) {
         return response.data
      } else {
         throw new Error(response.statusText)
      }
   } catch (err) {
      handleError(err)
      throw err
   }
}

export const postText = async (url: string, data: string): Promise<object> => {
   try {
      const response: AxiosResponse = await axios.post(url, `"${data}"`, {
         headers: { 'Content-Type': 'application/json' },
      })
      if (response.status === 200 || response.status === 201) {
         return response.data
      } else {
         throw new Error(response.statusText)
      }
   } catch (err) {
      handleError(err)
      throw err
   }
}

export const upload = async (
   url: string,
   formData: FormData,
   progressCallback?: ((progressEvent: ProgressEvent) => void) | undefined
): Promise<boolean> => {
   try {
      const response: AxiosResponse = await axios.post(url, formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
         onUploadProgress: progressCallback,
      })
      if (response.status === 200 || response.status === 201) {
         return true
      } else {
         throw new Error(response.statusText)
      }
   } catch (err) {
      handleError(err)
      throw err
   }
}

export const uploadWithResult = async (
   url: string,
   formData: FormData,
   progressCallback?: ((progressEvent: ProgressEvent) => void) | undefined
): Promise<CommitResult> => {
   try {
      const response: AxiosResponse = await axios.post(url, formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
         onUploadProgress: progressCallback,
      })
      if (response.status === 200 || response.status === 201) {
         return response.data
      } else {
         throw new Error(response.statusText)
      }
   } catch (err) {
      handleError(err)
      throw err
   }
}
